import { Inject, Injectable } from '@angular/core';
import { SESSION_STORAGE, StorageService } from 'ngx-webstorage-service';
import * as CryptoJS from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class StorageServices {
  secret: string = environment.secretKey;
  constructor(
    @Inject(SESSION_STORAGE) private storage: StorageService) { }
  encrypt(data: string | object, key: string): any {
    return CryptoJS.AES.encrypt(JSON.stringify(data), key).toString();
  }

  decrypt(data: string, key: string): any{
    const bytes = CryptoJS.AES.decrypt(data, key);
    if(bytes.toString(CryptoJS.enc.Utf8) != '') {
      return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    }
  }

  saveItem = (key: string, data: {}) => {
    return this.storage.set(
      key,
      this.encrypt(data, this.secret)
    );
  }

  getItem = async (key: string): Promise<string | object> => {
    return await new Promise((resolve) => {
      const encryptedRes = this.storage.get(key);

      if (encryptedRes != null) {
        resolve(this.decrypt(encryptedRes, this.secret));
      } else {
        resolve(encryptedRes);
      }

    });
  }

  removeItem = (key: string) => {
    return this.storage.remove(this.encrypt(key, this.secret));
  }

  clear = () => {
    return this.storage.clear();
  }

  persistStorage(currentDate: string) {
    if (!sessionStorage.length) {
      localStorage.setItem('getSessionStorage', currentDate);
    };
    window.addEventListener('storage', (event: any) => {
        if (event.key == 'getSessionStorage') {
            localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
            localStorage.removeItem('sessionStorage');

        } else if (event.key == 'sessionStorage' && !sessionStorage.length) {
            const data = JSON.parse(event.newValue);

            for (const key in data) {
                sessionStorage.setItem(key, data[key]);
            }
        }
    });
    // window.onbeforeunload = function() {
    //     sessionStorage.clear();
    // };
  }
}

